import Vue from 'vue';
import AlertComponent from './index.vue';
let AlertConstructor = Vue.extend(AlertComponent);

let Alert = function ({
  title = '提示',
  content = '',
  onOk = function () {},
  onCancel = function () {},
}) {
  let instance = new AlertConstructor({
    data: {
      title,
      content
    },
    methods: {
      onOk,
      onCancel,
    }
  })
  instance.$mount();
  document.body.appendChild(instance.$el)
  return instance;
}

let install = function (Vue) {
  Vue.prototype.$yxAlert = Alert;
}
export default install;



// WEBPACK FOOTER //
// ./src/components/yx-alert/index.js